/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { LengthUnit } from './LengthUnit';
import {
    LengthUnitFromJSON,
    LengthUnitFromJSONTyped,
    LengthUnitToJSON,
} from './LengthUnit';

/**
 * 
 * @export
 * @interface Length
 */
export interface Length {
    /**
     * 
     * @type {number}
     * @memberof Length
     */
    value?: number;
    /**
     * 
     * @type {LengthUnit}
     * @memberof Length
     */
    unit?: LengthUnit;
    /**
     * 
     * @type {string}
     * @memberof Length
     */
    $type?: LengthTypeEnum;
}


/**
 * @export
 */
export const LengthTypeEnum = {
    UnitsNetSerializationJsonNetUnitsNetBaseJsonConverter1ValueUnitUnitsNetIQuantityPtwUnitsNetPtwUnitsNetSerializationJsonNet: 'UnitsNet.Serialization.JsonNet.UnitsNetBaseJsonConverter`1+ValueUnit[[UnitsNet.IQuantity, Ptw.UnitsNet]], Ptw.UnitsNet.Serialization.JsonNet'
} as const;
export type LengthTypeEnum = typeof LengthTypeEnum[keyof typeof LengthTypeEnum];


/**
 * Check if a given object implements the Length interface.
 */
export function instanceOfLength(value?: unknown): value is Length {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(LengthTypeEnum)[0];
}

export function LengthFromJSON(json: any): Length {
    return LengthFromJSONTyped(json, false);
}

export function LengthFromJSONTyped(json: any, ignoreDiscriminator: boolean): Length {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'unit': !exists(json, 'unit') ? undefined : LengthUnitFromJSON(json['unit']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function LengthToJSON(value?: Length | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'value': value.value,
        'unit': LengthUnitToJSON(value.unit),
        '$type': value.$type,
    });
}

